// extracted by mini-css-extract-plugin
export default {"root":"BrowserWithPageRollingBones_root__hfybq","content":"BrowserWithPageRollingBones_content__yc-DM"};